module.exports = __webpack_public_path__ + "static/media/virtual-tour.6df45687.svg";